// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"504":"b79ddce5","732":"80e2b99f","977":"63419854"}[chunkId] + ".chunk.js";
};